// extracted by mini-css-extract-plugin
export default {"rating":"IQ-z","numberOfStars":"JQ-z","count":"KQ-z","barGraphSpacing":"LQ-z","barGraph":"MQ-z"};